import { gql } from '@apollo/client'

import {
  CaseTrackingBgCheckFromBgCheckOffersLock,
  CaseTrackingBGCheckFromLawsuitOffersLock,
  CustomPlanLock,
  DoctrineUnloggedLock,
  DynamicMultipleOffersSwitchFrequencyLock,
  InconsistentPlanLock,
  LawsuitNameMonitoringLock,
  LawsuitTwoOffersLock,
  LimitOverflowLock,
  LinkedAccountLock,
  OneOfferLock,
  PayPerViewLock,
  PixUpgradeLock,
  ThirdPartyBackgroundCheckLock,
  UpdatePaymentInfoLock,
  Upgrade2StepCurrentLayoutLock,
} from './components'
import { useSendViewItemEvent } from './hooks/use-send-view-item-event'

export const BoxLockQuery = gql`
  query BoxLockQuery(
    $appId: String
    $adminOptions: AdminOptionsInput = {}
    $featureCode: String!
    $fromComponent: String
    $boxOptions: BoxOptionsInput
    $pageMetadata: PageMetadataInput
  ) {
    root {
      boxLockViewer(
        appId: $appId
        adminOptions: $adminOptions
        featureCode: $featureCode
        fromComponent: $fromComponent
        boxOptions: $boxOptions
        pageMetadata: $pageMetadata
      ) {
        lockVariationType
        metadataToDebug
        offerLockData {
          body {
            cards {
              lockEventProperties {
                pid
                feature
                current_plan
                next_plan
                plan_price
                modal_type
                experiment_id
                app_id
                resource_id
                parent_resource_id
                from_component
                is_upgrade
                is_one_click
              }
            }

            ...UseSendViewItemEvent_offerLockBody
          }

          ...InconsistentPlanLock_offerLockData
          ...LimitOverflowLock_offerLockData
          ...UpdatePaymentInfoLock_offerLockData
          ...LinkedAccountLock_offerLockData
          ...OneOfferLock_offerLockData
          ...LawsuitTwoOffersLock_offerLockData
          ...LawsuitNameMonitoringLock_offerLockData
          ...PayPerViewLock_offerLockData
          ...ThirdPartyBackgroundCheckLock_offerLockData
          ...PixUpgradeLock_offerLockData
          ...CustomPlanLock_offerLockData
          ...CaseTrackingBgCheckFromBgCheckOffersLock_offerLockData
          ...CaseTrackingBGCheckFromLawsuitOffersLock_offerLockData
          ...DynamicMultipleOffersSwitchFrequencyLock_offerLockData
          ...DoctrineUnloggedLock_offerLockData
          ...Upgrade2StepCurrentLayoutLock_offerLockData
        }
      }

      viewer: me {
        user {
          isAdmin
        }
        ...OneOfferLock_viewer
        ...LawsuitTwoOffersLock_viewer
        ...LawsuitNameMonitoringLock_viewer
        ...PayPerViewLock_viewer
        ...ThirdPartyBackgroundCheckLock_viewer
        ...CustomPlanLock_viewer
        ...CaseTrackingBgCheckFromBgCheckOffersLock_viewer
        ...CaseTrackingBGCheckFromLawsuitOffersLock_viewer
        ...DynamicMultipleOffersSwitchFrequencyLock_viewer
        ...Upgrade2StepCurrentLayoutLock_viewer
      }
    }
  }
  ${useSendViewItemEvent.fragments.offerLockBody}
  ${InconsistentPlanLock.fragments.offerLockData}
  ${LimitOverflowLock.fragments.offerLockData}
  ${UpdatePaymentInfoLock.fragments.offerLockData}
  ${LinkedAccountLock.fragments.offerLockData}
  ${OneOfferLock.fragments.offerLockData}
  ${OneOfferLock.fragments.viewer}
  ${LawsuitTwoOffersLock.fragments.offerLockData}
  ${LawsuitTwoOffersLock.fragments.viewer}
  ${LawsuitNameMonitoringLock.fragments.offerLockData}
  ${LawsuitNameMonitoringLock.fragments.viewer}
  ${PayPerViewLock.fragments.offerLockData}
  ${PayPerViewLock.fragments.viewer}
  ${ThirdPartyBackgroundCheckLock.fragments.offerLockData}
  ${ThirdPartyBackgroundCheckLock.fragments.viewer}
  ${PixUpgradeLock.fragments.offerLockData}
  ${CustomPlanLock.fragments.offerLockData}
  ${CustomPlanLock.fragments.viewer}
  ${CaseTrackingBgCheckFromBgCheckOffersLock.fragments.offerLockData}
  ${CaseTrackingBgCheckFromBgCheckOffersLock.fragments.viewer}
  ${CaseTrackingBGCheckFromLawsuitOffersLock.fragments.offerLockData}
  ${CaseTrackingBGCheckFromLawsuitOffersLock.fragments.viewer}
  ${DynamicMultipleOffersSwitchFrequencyLock.fragments.offerLockData}
  ${DynamicMultipleOffersSwitchFrequencyLock.fragments.viewer}
  ${Upgrade2StepCurrentLayoutLock.fragments.offerLockData}
  ${Upgrade2StepCurrentLayoutLock.fragments.viewer}
  ${DoctrineUnloggedLock.fragments.offerLockData}
`
